/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemoDto } from '../../models/memo-dto';

export interface MemoControllerFindByIdV1$Params {
  id: string;
}

export function memoControllerFindByIdV1(http: HttpClient, rootUrl: string, params: MemoControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MemoDto>> {
  const rb = new RequestBuilder(rootUrl, memoControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MemoDto>;
    })
  );
}

memoControllerFindByIdV1.PATH = '/api/v1/memo/{id}';
